import axios from 'axios'
import { Strings } from 'INTL/i18n'
import { API_RESPONSE_STATUS_CODE } from '../config/axios.init'
// axios.defaults.withCredentials = true;

export default function baseAPIAction (
  API_Call_Details,
  actionCallback,
  config = {
    headers: {
      Authorization:
        'Bearer ' + localStorage.getItem('tokenPaymentApp_access_token')
    }
  },
  method = 'get',
  data = {}
) {
  let errorMessage = ''
  //console.log('CAlling API with details', API_Call_Details, config)
  switch (method) {
    case 'post':
      axios
        .post(API_Call_Details, data, config)
        .then(response => {
          success(response)
        })
        .catch(error => {
          // if (error.response.data.location) {
          //   window.location = error.response.data.location
          //   console.log("Inside post catch")
          // } else {
          //   return Promise.reject(error)
          // }
          //console.log('REQUEST******************', error)
          failure(error)
        })
      break
    case 'delete':
      axios
        .delete(API_Call_Details, config)
        .then(response => {
          success(response)
        })
        .catch(error => {
          failure(error)
        })
      break
    default:
      axios
        .get(API_Call_Details, config)
        .then(response => {
          success(response)
        })
        .catch(error => {
          failure(error)
        })
  }

  /**
   *  API success handling
   */
  let success = response => {
    localStorage.setItem('AccessTokenFlag', false)
    //console.log('API called In success', API_Call_Details, actionCallback)
    actionCallback('', response.data, response.status)
  }

  /**
   *  API failure handling
   */
  let failure = error => {
   // console.log('#########API called In failure', error)

    if (!error.response) {
      errorMessage = Strings('networkError')
    } else if (
      error.response.status === API_RESPONSE_STATUS_CODE.UNAUTHORIZED
    ) {
      if (
        API_RESPONSE_STATUS_CODE.UNAUTHORIZED &&
        error.response.data.error_description === 'INACTIVE'
      ) {
        errorMessage = Strings('inActiveUser')
        localStorage.removeItem('tokenPaymentApp_access_token')
      } else errorMessage = Strings('sessionExpired')
      localStorage.removeItem('tokenPaymentApp_access_token')
    } else if (error.response.status === API_RESPONSE_STATUS_CODE.BAD_REQUEST) {
      errorMessage = Strings('somethingWentWrong')
    } else {
      errorMessage = Strings('internalError')
    }
    actionCallback(errorMessage, error)
  }
}



// WEBPACK FOOTER //
// ./src/redux/BaseAPIAction.js